/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeCircleSIcon16Light } from './ShapeCircleSIcon16Light';
import { ShapeCircleSIcon16Regular } from './ShapeCircleSIcon16Regular';
import { ShapeCircleSIcon16Solid } from './ShapeCircleSIcon16Solid';
import { ShapeCircleSIcon20Light } from './ShapeCircleSIcon20Light';
import { ShapeCircleSIcon20Regular } from './ShapeCircleSIcon20Regular';
import { ShapeCircleSIcon20Solid } from './ShapeCircleSIcon20Solid';
import { ShapeCircleSIcon24Regular } from './ShapeCircleSIcon24Regular';
import { ShapeCircleSIcon24Solid } from './ShapeCircleSIcon24Solid';
import { ShapeCircleSIcon32Regular } from './ShapeCircleSIcon32Regular';
import { ShapeCircleSIcon64Regular } from './ShapeCircleSIcon64Regular';
var sizes = {
    16: {
        light: ShapeCircleSIcon16Light,
        regular: ShapeCircleSIcon16Regular,
        solid: ShapeCircleSIcon16Solid,
    },
    20: {
        light: ShapeCircleSIcon20Light,
        regular: ShapeCircleSIcon20Regular,
        solid: ShapeCircleSIcon20Solid,
    },
    24: {
        regular: ShapeCircleSIcon24Regular,
        solid: ShapeCircleSIcon24Solid,
    },
    32: {
        regular: ShapeCircleSIcon32Regular,
    },
    64: {
        regular: ShapeCircleSIcon64Regular,
    },
};
export var ShapeCircleSIcon = forwardRef('ShapeCircleSIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
